import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import usuarioService from '../services/UsuarioService';
import brandMark from '../assets/logos/logoAnimacion.png';
import './LandingPage.css';

const trustItems = [
  { icon: 'fa-solid fa-lock', label: 'Datos protegidos' },
  { icon: 'fa-solid fa-user-check', label: 'Usuarios administrados' },
  { icon: 'fa-solid fa-graduation-cap', label: 'Alineado a cada aprendizaje' }
];

const problemPoints = [
  {
    icon: 'fa-solid fa-circle-question',
    title: 'IA sin contexto',
    text: 'Las herramientas genéricas no conocen el curso, el material, el nivel ni los objetivos de cada estudiante.'
  },
  {
    icon: 'fa-solid fa-eye-slash',
    title: 'Uso difícil de acompañar',
    text: 'En una escuela, una clase particular o en casa, necesitás saber qué se está usando y con qué propósito.'
  },
  {
    icon: 'fa-solid fa-shapes',
    title: 'Recursos dispersos',
    text: 'Archivos, consignas, consultas, seguimiento y asistentes terminan separados en muchas herramientas distintas.'
  }
];

const howSteps = [
  {
    title: 'Elegís el tipo de espacio',
    text: 'Podés trabajar como institución, profesor particular o familia que acompaña el aprendizaje de un hijo o hija.'
  },
  {
    title: 'Organizás alumnos, cursos y aulas',
    text: 'Armás grupos, aulas y contenidos para que cada estudiante acceda a lo que realmente necesita.'
  },
  {
    title: 'Creás asistentes IA educativos',
    text: 'Configurás asistentes con materiales, instrucciones y objetivos concretos, sin depender de prompts sueltos.'
  },
  {
    title: 'Acompañás el uso',
    text: 'Consultás actividad, conversaciones y recursos para entender cómo se está usando la plataforma.'
  }
];

const benefits = [
  {
    icon: 'fa-solid fa-school',
    title: 'Para colegios',
    text: 'Aulas, cursos, docentes, alumnos, recursos y asistentes IA bajo una administración institucional.'
  },
  {
    icon: 'fa-solid fa-chalkboard-user',
    title: 'Para profesores particulares',
    text: 'Gestión simple de alumnos, clases, materiales, cuenta corriente y asistentes para cada curso.'
  },
  {
    icon: 'fa-solid fa-house-user',
    title: 'Para familias',
    text: 'Un espacio ordenado para acompañar a un hijo o hija con materiales, práctica y apoyo guiado.'
  },
  {
    icon: 'fa-solid fa-robot',
    title: 'Asistentes IA con propósito educativo',
    text: 'Asistentes configurados con contexto, archivos y reglas claras para responder mejor.'
  },
  {
    icon: 'fa-solid fa-chart-line',
    title: 'Seguimiento de actividad',
    text: 'Reportes y métricas para ver uso, consultas, aulas activas y recursos más utilizados.'
  },
  {
    icon: 'fa-solid fa-layer-group',
    title: 'Escalable según necesidad',
    text: 'Sirve para una institución completa, un profesor con varios alumnos o una familia que empieza de a poco.'
  }
];

const securityPillars = [
  {
    icon: 'fa-solid fa-shield-halved',
    title: 'Espacios privados',
    text: 'Cada institución, profesor o familia trabaja dentro de su propio entorno.'
  },
  {
    icon: 'fa-solid fa-lock',
    title: 'Datos protegidos',
    text: 'La información de alumnos y responsables se trata con resguardo y permisos definidos.'
  },
  {
    icon: 'fa-solid fa-check',
    title: 'Control de acceso',
    text: 'Los usuarios entran con permisos según su rol: administrador, profesor, alumno o responsable.'
  },
  {
    icon: 'fa-solid fa-eye',
    title: 'Uso observable',
    text: 'La actividad queda disponible para seguimiento y mejora continua.'
  }
];

const audienceCards = [
  {
    icon: 'fa-solid fa-school',
    title: 'Instituciones educativas',
    text: 'Para colegios, academias o centros educativos que necesitan administrar equipos, alumnos, aulas y asistentes con IA.'
  },
  {
    icon: 'fa-solid fa-chalkboard-user',
    title: 'Profesores particulares',
    text: 'Para docentes que trabajan con alumnos propios y quieren ordenar clases, materiales, asistentes IA y seguimiento.'
  },
  {
    icon: 'fa-solid fa-house-user',
    title: 'Familias',
    text: 'Para madres, padres o familiares que quieren acompañar el estudio de un hijo o hija en un entorno guiado.'
  }
];

const mockNav = [
  { icon: 'fa-solid fa-house', label: 'Inicio' },
  { icon: 'fa-solid fa-robot', label: 'Asistentes IA', active: true },
  { icon: 'fa-solid fa-folder-open', label: 'Archivos' },
  { icon: 'fa-solid fa-chalkboard', label: 'Pizarra', live: true },
  { icon: 'fa-solid fa-comments', label: 'Chat' },
  { icon: 'fa-solid fa-bullhorn', label: 'Foro' }
];

const requesterTypes = [
  { value: 'colegio', label: 'Colegio o institución educativa' },
  { value: 'profesor-particular', label: 'Profesor/a particular' },
  { value: 'familia', label: 'Familiar de un alumno/a' },
  { value: 'otro', label: 'Otro caso educativo' }
];

const studentRangeOptions = [
  { value: '', label: 'Seleccioná una opción' },
  { value: '1', label: '1 estudiante' },
  { value: '2-10', label: '2 a 10 estudiantes' },
  { value: '11-50', label: '11 a 50 estudiantes' },
  { value: '51-200', label: '51 a 200 estudiantes' },
  { value: '200+', label: 'Más de 200 estudiantes' }
];

const needOptions = [
  { value: '', label: 'Seleccioná una opción' },
  { value: 'demo', label: 'Quiero ver una demo' },
  { value: 'alta-particular', label: 'Quiero dar de alta una cuenta particular' },
  { value: 'colegio', label: 'Quiero implementarlo en una institución' },
  { value: 'familia', label: 'Quiero usarlo para acompañar a mi hijo/a' },
  { value: 'consulta', label: 'Tengo una consulta comercial' }
];

const testimonials = [
  {
    quote:
      'AluxIA nos permitió incorporar inteligencia artificial sin perder de vista lo que más nos importa: la seguridad de nuestros alumnos y nuestra propuesta pedagógica.',
    author: 'Director/a',
    org: '[Institución]'
  },
  {
    quote:
      'Por fin una herramienta que acompaña a los docentes en lugar de reemplazarlos. La diferencia se nota en el aula.',
    author: 'Coordinador/a pedagógico/a',
    org: '[Institución]'
  },
  {
    quote:
      'La implementación fue clara y el acompañamiento, constante. Tomar la decisión fue mucho más simple después de la demo.',
    author: 'Propietario/a',
    org: '[Institución]'
  }
];

const faqs = [
  {
    question: '¿AluxIA reemplaza a los docentes o a la familia?',
    answer:
      'No. AluxIA acompaña el aprendizaje. El criterio pedagógico, las decisiones y el seguimiento siguen siendo de los adultos responsables.'
  },
  {
    question: '¿También sirve para profesores particulares?',
    answer:
      'Sí. Un profesor particular puede gestionar alumnos, cursos, aulas, materiales, asistentes IA, reportes y cuenta corriente desde su propio panel.'
  },
  {
    question: '¿Una familia puede usarlo para su hijo o hija?',
    answer:
      'Sí. Una familia puede solicitar un espacio para organizar materiales, práctica y acompañamiento educativo para uno o más estudiantes.'
  },
  {
    question: '¿Qué pasa con los datos de los alumnos?',
    answer:
      'Los datos se tratan con resguardo y con permisos por rol. Cada cuenta mantiene control sobre sus usuarios, aulas y contenidos.'
  },
  {
    question: '¿Cómo se empieza?',
    answer:
      'Completás el formulario y coordinamos el caso: institución, profesor particular o familia. Después definimos la configuración inicial.'
  }
];

const initialDemoForm = {
  nombre: '',
  apellido: '',
  tipoSolicitante: 'colegio',
  institucion: '',
  email: '',
  telefono: '',
  cantidadAlumnos: '',
  necesidad: '',
  consulta: ''
};

// Oculto temporalmente hasta cargar los colegios reales.
const showSocialProofSection = false;
// Oculto temporalmente hasta tener listas las páginas legales.
const showLegalFooterColumn = false;
const contactEmail = 'info@aluxia.com.ar';
const whatsappLabel = '+54 9 351 343 0837';
const whatsappHref = 'https://wa.me/5493513430837';
const contactLocation = 'Córdoba, Córdoba, Argentina';
const getOptionLabel = (options, value) => options.find((option) => option.value === value)?.label || value || 'No informado';

const LandingPage = () => {
  const [navOpen, setNavOpen] = useState(false);
  const [demoForm, setDemoForm] = useState(initialDemoForm);
  const [demoLoading, setDemoLoading] = useState(false);
  const [demoError, setDemoError] = useState('');
  const [demoSuccess, setDemoSuccess] = useState('');
  const [showDemoCaptcha, setShowDemoCaptcha] = useState(false);
  const [demoCaptchaToken, setDemoCaptchaToken] = useState('');
  const demoCaptchaRef = useRef(null);
  const demoCaptchaWidgetId = useRef(null);

  useEffect(() => {
    if (!showDemoCaptcha) return;
    if (window.turnstile || document.getElementById('turnstile-script')) return;

    const script = document.createElement('script');
    script.id = 'turnstile-script';
    script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }, [showDemoCaptcha]);

  useEffect(() => {
    if (!showDemoCaptcha) return;
    if (demoCaptchaWidgetId.current) return;

    const timer = setInterval(() => {
      if (window.turnstile && demoCaptchaRef.current && !demoCaptchaWidgetId.current) {
        renderDemoCaptcha();
        clearInterval(timer);
      }
    }, 200);

    return () => clearInterval(timer);
  }, [showDemoCaptcha]);

  const handleDemoChange = (event) => {
    const { name, value } = event.target;
    setDemoForm((current) => ({ ...current, [name]: value }));
  };

  const closeNav = () => {
    setNavOpen(false);
  };

  const renderDemoCaptcha = () => {
    if (!demoCaptchaRef.current || !window.turnstile || demoCaptchaWidgetId.current) return;

    const siteKey = process.env.REACT_APP_TURNSTILE_SITE_KEY;
    if (!siteKey) {
      setDemoError('Captcha no configurado. Contacta al administrador.');
      return;
    }

    demoCaptchaWidgetId.current = window.turnstile.render(demoCaptchaRef.current, {
      sitekey: siteKey,
      callback: (token) => setDemoCaptchaToken(token),
      'error-callback': () => setDemoError('Captcha inválido. Intenta nuevamente.'),
      'expired-callback': () => setDemoCaptchaToken('')
    });
  };

  const handleDemoSubmit = async (event) => {
    event.preventDefault();
    setDemoError('');
    setDemoSuccess('');

    const nombre = demoForm.nombre.trim();
    const apellido = demoForm.apellido.trim();
    const tipoSolicitante = demoForm.tipoSolicitante.trim();
    const institucion = demoForm.institucion.trim();
    const email = demoForm.email.trim();
    const telefono = demoForm.telefono.trim();
    const cantidadAlumnos = demoForm.cantidadAlumnos.trim();
    const necesidad = demoForm.necesidad.trim();
    const consultaDetalle = demoForm.consulta.trim();

    if (!nombre || !apellido || !tipoSolicitante || !email || !consultaDetalle) {
      setDemoError('Completa los campos obligatorios.');
      return;
    }

    if (!showDemoCaptcha || !demoCaptchaToken) {
      setShowDemoCaptcha(true);
      setTimeout(renderDemoCaptcha, 50);
      setDemoError('Completa el captcha para continuar.');
      return;
    }

    const consulta = [
      'Solicitud desde la landing de AluxIA.',
      `Tipo de solicitante: ${getOptionLabel(requesterTypes, tipoSolicitante)}`,
      institucion ? `Institución, proyecto o familia: ${institucion}` : null,
      cantidadAlumnos ? `Cantidad estimada de estudiantes: ${getOptionLabel(studentRangeOptions, cantidadAlumnos)}` : null,
      necesidad ? `Necesidad principal: ${getOptionLabel(needOptions, necesidad)}` : null,
      telefono ? `Teléfono: ${telefono}` : null,
      `Mensaje: ${consultaDetalle}`
    ]
      .filter(Boolean)
      .join('\n');

    try {
      setDemoLoading(true);
      await usuarioService.createAccessRequest({
        nombre,
        apellido,
        telefono,
        email,
        consulta,
        captchaToken: demoCaptchaToken
      });
      setDemoSuccess('Gracias. Recibimos tu solicitud y te contactaremos pronto.');
      setDemoForm(initialDemoForm);
      setDemoCaptchaToken('');
      if (window.turnstile && demoCaptchaWidgetId.current) {
        window.turnstile.reset(demoCaptchaWidgetId.current);
      }
    } catch (error) {
      setDemoError(error.message || 'No pudimos enviar tu solicitud.');
    } finally {
      setDemoLoading(false);
    }
  };

  return (
    <div className="aluxia-landing">
      <header className="aluxia-site-header" id="inicio">
        <div className="aluxia-container aluxia-site-header__inner">
          <a className="aluxia-brand" href="#inicio" aria-label="AluxIA, inicio" onClick={closeNav}>
            <img src={brandMark} alt="" />
            <span>aluxIA</span>
          </a>

          <button
            className="aluxia-nav-toggle"
            type="button"
            aria-expanded={navOpen}
            aria-controls="aluxia-nav-menu"
            aria-label={navOpen ? 'Cerrar menú' : 'Abrir menú'}
            onClick={() => setNavOpen((open) => !open)}
          >
            <span className="aluxia-nav-toggle__bar" aria-hidden="true" />
            <span className="aluxia-nav-toggle__bar" aria-hidden="true" />
            <span className="aluxia-nav-toggle__bar" aria-hidden="true" />
          </button>

          <nav
            className={`aluxia-nav${navOpen ? ' is-open' : ''}`}
            id="aluxia-nav-menu"
            aria-label="Principal"
          >
            <a className="aluxia-nav__link" href="#como-funciona" onClick={closeNav}>
              Cómo funciona
            </a>
            <a className="aluxia-nav__link" href="#para-quien" onClick={closeNav}>
              Para quién
            </a>
            <a className="aluxia-nav__link" href="#beneficios" onClick={closeNav}>
              Beneficios
            </a>
            <a className="aluxia-nav__link" href="#seguridad" onClick={closeNav}>
              Seguridad
            </a>
            {/* Oculto temporalmente hasta cargar los colegios reales. */}
            {showSocialProofSection && (
              <a className="aluxia-nav__link" href="#casos" onClick={closeNav}>
                Casos
              </a>
            )}
            <a className="aluxia-nav__link" href="#faq" onClick={closeNav}>
              Preguntas
            </a>
            <a className="aluxia-btn aluxia-btn--primary aluxia-nav__cta" href="#demo" onClick={closeNav}>
              Solicitar demo o acceso
            </a>
            <Link className="aluxia-btn aluxia-btn--ghost aluxia-nav__login" to="/login" onClick={closeNav}>
              Ingresar
            </Link>
          </nav>
        </div>
      </header>

      <main>
        <section className="aluxia-hero" aria-labelledby="hero-title">
          <div className="aluxia-container aluxia-hero__inner">
            <div className="aluxia-hero__content">
              <p className="aluxia-eyebrow">AluxIA · Para colegios, profesores particulares y familias</p>
              <h1 id="hero-title" className="aluxia-hero__title">
                IA educativa con <span>contexto, control y seguimiento</span>
              </h1>
              <p className="aluxia-hero__subtitle">
                Una plataforma para crear aulas, organizar estudiantes y usar asistentes IA educativos con contexto, control y
                seguimiento. Sirve para una institución completa, una clase particular o el acompañamiento familiar en casa.
              </p>
              <div className="aluxia-hero__actions">
                <a className="aluxia-btn aluxia-btn--primary aluxia-btn--lg" href="#demo">
                  Solicitar demo o acceso
                </a>
                <Link className="aluxia-btn aluxia-btn--secondary aluxia-btn--lg" to="/login">
                  Ingresar
                </Link>
              </div>
              <p className="aluxia-hero__microcopy">Sin compromiso. Te mostramos el mejor formato para tu caso.</p>
              <ul className="aluxia-trust-strip" aria-label="Garantías de AluxIA">
                {trustItems.map((item) => (
                  <li className="aluxia-trust-strip__item" key={item.label}>
                    <i className={item.icon} aria-hidden="true" />
                    <span>{item.label}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="aluxia-hero__media" aria-label="Vista previa de AluxIA">
              <div className="aluxia-mock">
                <div className="aluxia-mock__bar">
                  <span />
                  <span />
                  <span />
                  <p>Aula · Apoyo escolar</p>
                </div>
                <div className="aluxia-mock__body">
                  <ul className="aluxia-mock__nav" aria-hidden="true">
                    {mockNav.map((item) => (
                      <li className={item.active ? 'is-active' : ''} key={item.label}>
                        <i className={item.icon} />
                        <span>{item.label}</span>
                        {item.live && <b />}
                      </li>
                    ))}
                  </ul>
                  <div className="aluxia-mock__chat">
                    <div className="aluxia-chat-line aluxia-chat-line--user">
                      Necesito practicar fracciones y entender dónde me equivoco.
                    </div>
                    <div className="aluxia-chat-line aluxia-chat-line--assistant">
                      Trabajemos con ejemplos cortos, revisemos el procedimiento y dejemos registro para que tu profesor o
                      familia pueda acompañarte.
                    </div>
                    <div className="aluxia-product-card__chips">
                      <span>Materiales</span>
                      <span>Asistentes IA</span>
                      <span>Seguimiento</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="aluxia-product-metric aluxia-product-metric--one">
                <strong>3</strong>
                <span>tipos de cuenta</span>
              </div>
              <div className="aluxia-product-metric aluxia-product-metric--two">
                <strong>1</strong>
                <span>entorno ordenado</span>
              </div>
            </div>
          </div>
        </section>

        <section className="aluxia-problem" aria-labelledby="problem-title">
          <div className="aluxia-container">
            <p className="aluxia-kicker">El desafío</p>
            <h2 id="problem-title" className="aluxia-section-title aluxia-section-title--narrow">
              La IA ya está en el aprendizaje. El desafío es usarla con contexto.
            </h2>
            <p className="aluxia-section-lead">
              AluxIA reúne aulas, materiales, estudiantes y asistentes en un espacio educativo. Funciona para equipos
              escolares, profesores particulares y familias que quieren acompañar mejor el estudio.
            </p>
            <ul className="aluxia-problem__points">
              {problemPoints.map((point) => (
                <li className="aluxia-problem-point" key={point.title}>
                  <span className="aluxia-card-icon" aria-hidden="true">
                    <i className={point.icon} />
                  </span>
                  <h3>{point.title}</h3>
                  <p>{point.text}</p>
                </li>
              ))}
            </ul>
          </div>
        </section>

        <section id="para-quien" className="aluxia-audiences" aria-labelledby="audiences-title">
          <div className="aluxia-container">
            <p className="aluxia-kicker aluxia-kicker--center">Para quién</p>
            <h2 id="audiences-title" className="aluxia-section-title aluxia-section-title--center">
              Para quién es AluxIA
            </h2>
            <p className="aluxia-section-lead aluxia-section-lead--center">
              La misma base tecnológica se adapta a tres necesidades educativas: gestión institucional, clases
              particulares y acompañamiento familiar.
            </p>
            <ul className="aluxia-audiences__grid">
              {audienceCards.map((audience) => (
                <li className="aluxia-audience-card" key={audience.title}>
                  <span className="aluxia-audience-card__icon" aria-hidden="true">
                    <i className={audience.icon} />
                  </span>
                  <h3>{audience.title}</h3>
                  <p>{audience.text}</p>
                </li>
              ))}
            </ul>
          </div>
        </section>

        <section id="como-funciona" className="aluxia-how" aria-labelledby="how-title">
          <div className="aluxia-container">
            <p className="aluxia-kicker aluxia-kicker--center">Cómo funciona</p>
            <h2 id="how-title" className="aluxia-section-title aluxia-section-title--center">
              Cómo funciona AluxIA
            </h2>
            <ol className="aluxia-how__steps">
              {howSteps.map((step, index) => (
                <li className="aluxia-step" key={step.title}>
                  <span className="aluxia-step__num" aria-hidden="true">
                    {index + 1}
                  </span>
                  <h3>{step.title}</h3>
                  <p>{step.text}</p>
                </li>
              ))}
            </ol>
            <div className="aluxia-section-cta">
              <p>¿Querés ver cómo se aplicaría en tu caso?</p>
              <a className="aluxia-btn aluxia-btn--primary aluxia-btn--lg" href="#demo">
                Solicitar demo o acceso
              </a>
            </div>
          </div>
        </section>

        <section id="beneficios" className="aluxia-benefits" aria-labelledby="benefits-title">
          <div className="aluxia-container">
            <p className="aluxia-kicker aluxia-kicker--center">Beneficios</p>
            <h2 id="benefits-title" className="aluxia-section-title aluxia-section-title--center">
              Lo que AluxIA aporta
            </h2>
            <ul className="aluxia-benefits__grid">
              {benefits.map((benefit) => (
                <li className="aluxia-benefit" key={benefit.title}>
                  <span className="aluxia-card-icon" aria-hidden="true">
                    <i className={benefit.icon} />
                  </span>
                  <h3>{benefit.title}</h3>
                  <p>{benefit.text}</p>
                </li>
              ))}
            </ul>
          </div>
        </section>

        <section id="seguridad" className="aluxia-security" aria-labelledby="security-title">
          <div className="aluxia-container">
            <p className="aluxia-kicker aluxia-kicker--center">Seguridad</p>
            <h2 id="security-title" className="aluxia-section-title aluxia-section-title--center">
              Seguridad y control desde el primer día
            </h2>
            <p className="aluxia-security__intro">
              Sabemos que la responsabilidad sobre los estudiantes no se delega. Por eso AluxIA trabaja con permisos,
              espacios privados y seguimiento de actividad para cada tipo de cuenta.
            </p>
            <ul className="aluxia-security__pillars">
              {securityPillars.map((pillar) => (
                <li className="aluxia-pillar" key={pillar.title}>
                  <span className="aluxia-pillar__icon" aria-hidden="true">
                    <i className={pillar.icon} />
                  </span>
                  <h3>{pillar.title}</h3>
                  <p>{pillar.text}</p>
                </li>
              ))}
            </ul>
            <div className="aluxia-security__actions">
              <a className="aluxia-security__deeplink" href="#demo">
                Consultar prácticas de seguridad y resguardo
              </a>
              <a className="aluxia-btn aluxia-btn--primary" href="#demo">
                Solicitar demo o acceso
              </a>
            </div>
          </div>
        </section>

        {/* Oculto temporalmente hasta cargar los colegios reales. */}
        {showSocialProofSection && (
          <section id="casos" className="aluxia-social-proof" aria-labelledby="social-proof-title">
            <div className="aluxia-container">
              <h2 id="social-proof-title" className="aluxia-section-title aluxia-section-title--center">
                Instituciones que ya confían en AluxIA
              </h2>
              <ul className="aluxia-testimonials">
                {testimonials.map((testimonial) => (
                  <li className="aluxia-testimonial" key={testimonial.quote}>
                    <blockquote>{testimonial.quote}</blockquote>
                    <p>
                      {testimonial.author}, <span>{testimonial.org}</span>
                    </p>
                  </li>
                ))}
              </ul>
              <p className="aluxia-social-proof__orgs-label">Instituciones que trabajan con AluxIA</p>
              <ul className="aluxia-social-proof__orgs" aria-label="Instituciones que trabajan con AluxIA">
                <li>[Institución]</li>
                <li>[Institución]</li>
                <li>[Institución]</li>
                <li>[Institución]</li>
              </ul>
            </div>
          </section>
        )}

        <section id="faq" className="aluxia-faq" aria-labelledby="faq-title">
          <div className="aluxia-container">
            <p className="aluxia-kicker aluxia-kicker--center">Preguntas</p>
            <h2 id="faq-title" className="aluxia-section-title aluxia-section-title--center">
              Preguntas frecuentes
            </h2>
            <div className="aluxia-faq__list">
              {faqs.map((faq) => (
                <details className="aluxia-faq-item" key={faq.question}>
                  <summary>{faq.question}</summary>
                  <p>{faq.answer}</p>
                </details>
              ))}
            </div>
          </div>
        </section>

        <section id="demo" className="aluxia-demo" aria-labelledby="demo-title">
          <div className="aluxia-container aluxia-demo__inner">
            <div className="aluxia-demo__pitch">
              <p className="aluxia-kicker">Contacto</p>
              <h2 id="demo-title" className="aluxia-section-title">
                Contanos tu caso y coordinamos el próximo paso
              </h2>
              <p>
                Decinos si querés usar AluxIA como institución, profesor particular o familia. Con esa información te
                mostramos una demo o te guiamos para crear el espacio que corresponda.
              </p>
              <ul className="aluxia-demo__reassurance">
                <li>Demo orientada a tu caso real</li>
                <li>Alta para cuentas particulares o institucionales</li>
                <li>Acompañamiento en la configuración inicial</li>
              </ul>
            </div>

            <form className="aluxia-demo__form" onSubmit={handleDemoSubmit}>
              <div className="aluxia-field">
                <label htmlFor="demo-tipo">Estoy consultando como</label>
                <select
                  id="demo-tipo"
                  name="tipoSolicitante"
                  value={demoForm.tipoSolicitante}
                  onChange={handleDemoChange}
                  disabled={demoLoading}
                  required
                >
                  {requesterTypes.map((option) => (
                    <option value={option.value} key={option.value}>{option.label}</option>
                  ))}
                </select>
              </div>
              <div className="aluxia-demo__form-grid">
                <div className="aluxia-field">
                  <label htmlFor="demo-nombre">Nombre</label>
                  <input
                    type="text"
                    id="demo-nombre"
                    name="nombre"
                    autoComplete="given-name"
                    value={demoForm.nombre}
                    onChange={handleDemoChange}
                    disabled={demoLoading}
                    required
                  />
                </div>
                <div className="aluxia-field">
                  <label htmlFor="demo-apellido">Apellido</label>
                  <input
                    type="text"
                    id="demo-apellido"
                    name="apellido"
                    autoComplete="family-name"
                    value={demoForm.apellido}
                    onChange={handleDemoChange}
                    disabled={demoLoading}
                    required
                  />
                </div>
              </div>
              <div className="aluxia-field">
                <label htmlFor="demo-institucion">
                  Institución, proyecto o familia <span>(opcional)</span>
                </label>
                <input
                  type="text"
                  id="demo-institucion"
                  name="institucion"
                  autoComplete="organization"
                  value={demoForm.institucion}
                  onChange={handleDemoChange}
                  disabled={demoLoading}
                />
              </div>
              <div className="aluxia-field">
                <label htmlFor="demo-email">Email de contacto</label>
                <input
                  type="email"
                  id="demo-email"
                  name="email"
                  autoComplete="email"
                  value={demoForm.email}
                  onChange={handleDemoChange}
                  disabled={demoLoading}
                  required
                />
              </div>
              <div className="aluxia-demo__form-grid">
                <div className="aluxia-field">
                  <label htmlFor="demo-cantidad">Cantidad estimada de estudiantes</label>
                  <select
                    id="demo-cantidad"
                    name="cantidadAlumnos"
                    value={demoForm.cantidadAlumnos}
                    onChange={handleDemoChange}
                    disabled={demoLoading}
                  >
                    {studentRangeOptions.map((option) => (
                      <option value={option.value} key={option.value}>{option.label}</option>
                    ))}
                  </select>
                </div>
                <div className="aluxia-field">
                  <label htmlFor="demo-necesidad">Necesidad principal</label>
                  <select
                    id="demo-necesidad"
                    name="necesidad"
                    value={demoForm.necesidad}
                    onChange={handleDemoChange}
                    disabled={demoLoading}
                  >
                    {needOptions.map((option) => (
                      <option value={option.value} key={option.value}>{option.label}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="aluxia-field">
                <label htmlFor="demo-telefono">
                  Teléfono <span>(opcional)</span>
                </label>
                <input
                  type="tel"
                  id="demo-telefono"
                  name="telefono"
                  autoComplete="tel"
                  value={demoForm.telefono}
                  onChange={handleDemoChange}
                  disabled={demoLoading}
                />
              </div>
              <div className="aluxia-field">
                <label htmlFor="demo-consulta">Qué querés resolver</label>
                <textarea
                  id="demo-consulta"
                  name="consulta"
                  rows="4"
                  value={demoForm.consulta}
                  onChange={handleDemoChange}
                  disabled={demoLoading}
                  placeholder="Ej.: quiero usarlo con mis alumnos particulares, implementarlo en mi colegio o acompañar el estudio de mi hijo/a."
                  required
                />
              </div>
              {showDemoCaptcha && <div className="aluxia-demo__captcha" ref={demoCaptchaRef} />}
              {demoError && (
                <p className="aluxia-demo__message aluxia-demo__message--error" role="alert">
                  {demoError}
                </p>
              )}
              {demoSuccess && (
                <p className="aluxia-demo__message aluxia-demo__message--success" role="status">
                  {demoSuccess}
                </p>
              )}
              <button
                className="aluxia-btn aluxia-btn--primary aluxia-btn--lg aluxia-btn--block"
                type="submit"
                disabled={demoLoading}
              >
                {demoLoading ? 'Enviando...' : 'Enviar consulta'}
              </button>
              <p className="aluxia-demo__privacy">
                <i className="fa-solid fa-lock" aria-hidden="true" />
                Cuidamos tus datos. Solo los usamos para responder tu consulta.
              </p>
            </form>
          </div>
        </section>
      </main>

      <footer className="aluxia-site-footer">
        <div
          className={`aluxia-container aluxia-site-footer__inner${
            showLegalFooterColumn ? '' : ' aluxia-site-footer__inner--legal-hidden'
          }`}
        >
          <div className="aluxia-site-footer__brand">
            <div className="aluxia-brand aluxia-brand--light">
              <img src={brandMark} alt="" />
              <span>aluxIA</span>
            </div>
            <p>IA educativa para instituciones, profesores particulares y familias.</p>
          </div>
          <nav className="aluxia-site-footer__col" aria-label="Contacto">
            <h2>Contacto</h2>
            <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
            <a href={whatsappHref} target="_blank" rel="noreferrer">
              WhatsApp {whatsappLabel}
            </a>
            <p>{contactLocation}</p>
          </nav>
          {showLegalFooterColumn && (
            <nav className="aluxia-site-footer__col" aria-label="Legal">
              <h2>Legal</h2>
              <a href="/privacidad">Política de privacidad</a>
              <a href="/terminos">Términos y condiciones</a>
            </nav>
          )}
          <nav className="aluxia-site-footer__col" aria-label="Acceso">
            <h2>Acceso</h2>
            <Link to="/login">Ingresar</Link>
            <a className="aluxia-site-footer__cta" href="#demo">
              Solicitar demo o acceso
            </a>
          </nav>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
